import { withJsonFormsControlProps } from '@jsonforms/react'
import { Font } from '@pepsico-ds/ui'
import PropTypes from 'prop-types'

/**
 * Label component to display a label and corresponding data.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.data - The data to be displayed.
 * @param {string} props.label - The label text.
 * @param {string} props.id - The unique identifier for the section.
 * @returns {JSX.Element} The rendered Label component.
 */
const LabelField = ({ data, label, id }) => {
  return (
    <section key={id} data-testid={`label-field-${id}`}>
      <Font size="xsmall" data-testid={`label-${id}`}>
        {label}
      </Font>
      <section data-testid={`data-${id}`}>
        <Font size="body" style={{ fontWeight: 'bold' }}>
          {data}
        </Font>
      </section>
    </section>
  )
}

LabelField.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  id: PropTypes.string,
}

const Label = withJsonFormsControlProps(LabelField)
export default Label

